import { getSetting, getSettingLabel } from '@koob/utils';

function placeName(name) {
  return name?.split(',')[0]?.trim() || name;
}

export default function ExportDayPois({ pois, settings }) {
  const daysSection = getSetting(settings, 'days');
  const poisLabel = getSettingLabel(
    daysSection?.sections,
    'points-of-interest',
  );

  if (!pois?.length) return null;

  const row = (poi, index) => (
    <div
      key={poi?.id ?? index}
      className={[
        'flex items-center gap-4 py-2',
        index > 0 ? 'border-t border-k-gray/40' : '',
      ].join(' ')}
      data-prevent-cut={index > 0 || undefined}
    >
      <div className="relative flex aspect-[4/3] h-16 flex-shrink-0 items-center justify-center overflow-hidden bg-[var(--td-primary-soft)]">
        <div className="absolute left-1.5 top-1.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white bg-[var(--td-primary)] text-3xs font-bold text-white shadow">
          {index + 1}
        </div>
        <div
          className="text-2xl italic text-[var(--td-primary)]"
          style={{ fontFamily: 'var(--td-font-display)' }}
        >
          {index + 1}
        </div>
      </div>

      <div className="min-w-0">
        <div className="font-medium leading-snug">{placeName(poi?.name)}</div>
      </div>
    </div>
  );

  return (
    <div>
      <div data-prevent-cut>
        <div className="text-2xs font-semibold tracking-widest uppercase text-[var(--td-primary)]">
          {poisLabel}
        </div>
        <div className="mt-3">{row(pois[0], 0)}</div>
      </div>

      {pois.slice(1).map((poi, index) => row(poi, index + 1))}
    </div>
  );
}
